// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"cf51c170","247":"7ca0f93e","331":"5ae43928","459":"adfdaacc","496":"46e6eb25"}[chunkId] + ".chunk.js";
};